import React, { useContext } from "react";
import useSiteData from '../../useSiteData'
import ContactBlock from "../organisms/ContactBlock";
import LinkBlock from "./LinkBlock";
import FooterInformation from "../molecules/FooterInformation";
import Newsletter from "../molecules/Newsletter";
import Divider from "../molecules/WaveDivider";
import Logo from "../molecules/Logo";
import IconText from "../molecules/IconText";
import { HeaderThemeContext, headerThemes } from "../../context";

const fixContactContentForRender = obj => {
    if (obj?.nodeType == 'text' && !obj.marks) {
        obj.marks = []
    }
    Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] == 'object') {
            fixContactContentForRender(obj[key])
        }
        if (obj[key] === null) {
            delete obj[key]
        }
    })
}

export default () => {
    const {
        footerNewsletterTitle: newsletterTitle,
        footerNewsletterPlaceholder: newsletterPlaceholder,
        footerPrimaryNavTitle: primaryNavTitle,
        footerPrimaryNavLinks: primaryNavLinks,
        footerSecondaryNavTitle: secondaryNavTitle,
        footerSecondaryNavLinks: secondaryNavLinks,
        footerSocialMediaTitle: socialMediaTitle,
        footerSocialMediaLinks: socialMediaLinks,
        footerContactTitle: contactTitle,
        footerContactContent: contactContent,
        footerInformationLinks: informationLinks,
        footerContactLink: contactLink,
        footerFeatures: features,
        organisation
    } = useSiteData().pageSettings;

    fixContactContentForRender(contactContent)

    const { theme } = useContext(HeaderThemeContext);

    if (theme === headerThemes.INVISIBLE) return null;

    return (
        <footer className="o-footer u-section-spacing" role="contentinfo">
            <div className="o-footer__features o-footer__grid o-footer__grid--sm-2-col u-container">
                <div className="o-footer__item">
                    <Logo className=" a-icon--red"/>
                </div>
                { features.map((item, index) => (
                    <div className="o-footer__item" key={ index }>
                        <IconText { ...item }/>
                    </div>
                )) }
            </div>
            <div className="u-background">
                <div className="u-container u-container--large">
                    <Newsletter title={ newsletterTitle }
                                placeholder={ newsletterPlaceholder }/>
                </div>
            </div>
            <div className="u-container">
                <div className="o-footer__grid u-small-text">
                    <LinkBlock
                        className=" o-link-block--variation"
                        title={ primaryNavTitle }
                        links={ primaryNavLinks }
                    />
                    <LinkBlock
                        className=" o-link-block--variation"
                        title={ secondaryNavTitle }
                        links={ secondaryNavLinks }
                    />
                    <LinkBlock
                        className=" o-link-block--variation"
                        title={ socialMediaTitle }
                        links={ socialMediaLinks }
                        listSocialMedia
                    />
                    <ContactBlock
                        title={ contactTitle }
                        content={ contactContent }
                        link={ contactLink }
                    />
                </div>

                <Divider/>
                <FooterInformation links={ informationLinks } organisation={ organisation }/>
            </div>
        </footer>
    );
}
